import { render } from "./toggler.vue?vue&type=template&id=879861da&scoped=true&ts=true"
import script from "./toggler.vue?vue&type=script&lang=ts"
export * from "./toggler.vue?vue&type=script&lang=ts"

import "./toggler.vue?vue&type=style&index=0&id=879861da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-879861da"]])

export default __exports__